import {handleActions, combineActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {DEFAULT_FEED_NAME_KEY, DEFAULT_LEAVE_TYPE_SELECTION, DEFAULT_SHARED_WITH_USER_SELECTION, DEFAULT_USER_SELECTION} from './constants'
import {ICalLightboxType} from '../../constants'
import messageResource from '../../../../../js/messageResource'
import {getDefaultDateRange} from '../../utils'
import {EDIT_FEED_LOAD_DATA} from './actionTypes'
import {EXPORT_ICAL_LOAD_DATA} from './actionTypes'

const createICalLightBoxReducer = () => {
    const initialState = {
        lightboxType: null,
        editedFeedId: null,
        feedName: messageResource.getMessage(DEFAULT_FEED_NAME_KEY),
        feedLeaveTypeSelection: DEFAULT_LEAVE_TYPE_SELECTION,
        includeNotApproved: false,
        userSelection: DEFAULT_USER_SELECTION,
        sharedUserSelection: DEFAULT_SHARED_WITH_USER_SELECTION,
        dateRangeSelection: null,
        dateRangeValid: false,
        lightboxLoading: false,
    }

    return handleActions({
        [ActionTypes.LIGHTBOX_TYPE_SET]: (state, {payload: lightboxType}) => ({...state, lightboxType}),
        [ActionTypes.FEED_NAME_SET]: (state, {payload: feedName}) => ({...state, feedName: feedName.trim()}),
        [ActionTypes.USER_SELECTION_SET]: (state, {payload: userSelection}) => ({...state, userSelection}),
        [ActionTypes.SHARED_USER_SELECTION_SET]: (state, {payload: sharedUserSelection}) => ({...state, sharedUserSelection}),
        [ActionTypes.LEAVE_TYPE_SELECTION_SET]: (state, {payload: feedLeaveTypeSelection}) => ({...state, feedLeaveTypeSelection}),
        [ActionTypes.INCLUDE_NOT_APPROVED_SET]: (state, {payload: includeNotApproved}) => ({...state, includeNotApproved}),
        [ActionTypes.DATE_RANGE_SELECITON_SET]: (state, {payload: {dateRangeSelection, dateRangeValid}}) => ({...state, dateRangeSelection, dateRangeValid}),
        [ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS]: (state) => ({...state, ...initialState, lightboxType: ICalLightboxType.CREATE}),
        [ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS]: (state) => ({
            ...state,
            ...initialState,
            lightboxType: ICalLightboxType.EXPORT,
            dateRangeSelection: getDefaultDateRange(),
            dateRangeValid: true,
        }),
        [ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS]: (state, {payload: feed}) =>
            ({
                ...state,
                lightboxType: ICalLightboxType.EDIT,
                editedFeedId: feed.id,
                feedName: feed.name,
                feedLeaveTypeSelection: feed.leaveTypesFilter,
                includeNotApproved: feed.leaveTypesFilter.includeNotApproved,
                userSelection: feed.usersFilter,
                sharedUserSelection: feed.sharedUsersFilter,
            }),
        [combineActions(ActionTypes.CLOSE_ICAL_LIGHTBOX,
            ActionTypes.CREATE_FEED_LOAD_DATA_SUCCESS,
            ActionTypes.CREATE_FEED_LOAD_DATA_FAILURE,
            ActionTypes.EDIT_FEED_LOAD_DATA_SUCCESS,
            ActionTypes.EDIT_FEED_LOAD_DATA_FAILURE,
            ActionTypes.EXPORT_ICAL_LOAD_DATA_SUCCESS,
            ActionTypes.EXPORT_ICAL_LOAD_DATA_FAILURE,
        )]: (state) => ({
            ...state,
            lightboxType: null,
            feedLeaveTypeSelection: null,
            userSelection: null,
            sharedUserSelection: null,
            dateRangeSelection: null,
        }),
        [combineActions(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD,
            ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD,
            ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD)]: (state) => ({...state, lightboxLoading: true}),
        [combineActions(ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS,
            ActionTypes.CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE,
            ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS,
            ActionTypes.EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE,
            ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS,
            ActionTypes.EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE
        )]: (state) => ({...state, lightboxLoading: false}),
    }, initialState)
}

export default createICalLightBoxReducer



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/reducer.js